import { StandardEvents } from '@shopify/events';
import { classifyVisit, successfulCartAdd } from '@theme/binary-shopping-logic';

// The existing app remains responsible for Clarity loading/consent. No new tracker,
// cookies, customer IDs, raw errors, search terms or personal data are added here.
if (!window.Shopify?.designMode) {
  const queued = [];
  let attempts = 0;
  let timer;
  const flush = () => {
    if (typeof window.clarity === 'function') {
      while (queued.length) window.clarity(...queued.shift());
      clearInterval(timer);
    } else if (++attempts >= 20) {
      queued.length = 0;
      clearInterval(timer);
    }
  };
  const send = (...args) => {
    if (typeof window.clarity === 'function') window.clarity(...args);
    else if (attempts < 20 && queued.length < 40) queued.push(args);
  };
  timer = setInterval(flush, 500);
  const track = (name) => send('event', name);
  const main = document.querySelector('#MainContent');
  let externalEntry = !document.referrer;
  try { externalEntry = new URL(document.referrer).origin !== location.origin; } catch { /* Direct visit. */ }
  // Do not overwrite acquisition tags when a shopper follows internal links.
  const params = new URLSearchParams(location.search);
  if (externalEntry || ['utm_source','gclid','gbraid','wbraid'].some(key => params.has(key))) {
    Object.entries(classifyVisit(location.search, document.referrer, navigator.userAgent, window.innerWidth)).forEach(([key,value]) => send('set',key,value));
  }
  // Entry precedes product view for visitors landing directly on a product.
  if (externalEntry) track('bh_landing_page');
  const product = main?.dataset.productHandle;
  if (product) {
    send('set', 'bh_product', product);
    track('bh_product_view');
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-bh-event]');
    const allowed = ['bh_hero_product_click','bh_computer_archive_click','bh_future_places_click'];
    if (link && allowed.includes(link.dataset.bhEvent)) track(link.dataset.bhEvent);
    // Intent only. Checkout started/purchase must come from Shopify's checkout pixel.
    if (event.target.closest('button[name="checkout"], a[href="/checkout"]')) track('bh_checkout_click');
  });
  document.addEventListener(StandardEvents.productSelect, (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.product-details')) return;
    Promise.resolve(event.promise).then(result => {
      if (result?.detail?.resource?.id) track('bh_variant_selected');
    }).catch(() => track('bh_variant_resolution_error'));
  });
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('product-form-component')) return;
    Promise.resolve(event.promise).then(result => {
      if (successfulCartAdd(result)) track('bh_add_to_cart');
    }).catch(() => track('bh_cart_error'));
  });
  // Record error categories, not potentially sensitive exception messages/URLs.
  const errorKinds = new Set();
  const reportError = (kind) => {
    if (errorKinds.has(kind)) return;
    errorKinds.add(kind);
    send('set','bh_js_error','yes');
    send('set','bh_js_error_kind',kind);
  };
  window.addEventListener('error', () => reportError('javascript'));
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.name === 'AbortError') return;
    const message = String(event.reason?.message || '');
    reportError(/dynamically imported|module script|importing a module/i.test(message) ? 'module_load' : 'promise');
  });
  flush();
}
